<template>
  <div
    :class="className"
    @click.stop="onOptionClick"
    @mouseenter="onOptionMouseEnter"
  >
    <ten-checkbox
      v-if="select.multiple && select.optionCheckbox"
      :checked="isChecked"
      :disabled="disabled"
    />
    <slot>
      <template v-if="select.renderOption && data">
        <render-cell
          :render="select.renderOption"
          :data="data"
        />
      </template>
      <template v-else>
        {{ label }}
      </template>
    </slot>
  </div>
</template>

<script>
import TenCheckbox from '../checkbox';
import RenderCell from '../render-cell';

const name = 'ten-select-option';

export default {
  name,
  components: {
    TenCheckbox,
    RenderCell,
  },
  inject: ['select'],
  props: {
    /**
     * 选项的值，唯一
     */
    value: {
      type: [String, Number],
    },
    /**
     * 选项的显示值。当值为空字符串、undefined、null时取value的值。
     */
    label: [String, Number],
    /**
     * 选项的全量数据，当value-type="data"时，需要传入
     */
    data: [Object, String, Number],
    /**
     * 选项禁用
     */
    disabled: Boolean,
    /**
     * @ignore
     */
    index: Number,
    /**
     * @ignore
     */
    optionObj: Object,
    isChecked: Boolean,
    isSelectAll: Boolean,
  },
  computed: {
    className() {
      const dataLength = this.select.dataValue.length;
      const { focusIndex } = this.select;

      const isLabel = this.select.focusLabel === this.label;
      const isIndex = focusIndex === this.index;

      let isFocus = false;
      if (dataLength > 0) {
        isFocus = isLabel;
      } else if (focusIndex > -1) {
        isFocus = isIndex;
      } else {
        isFocus = isLabel;
      }
      // const isFocus = dataLength > 0 ? isLabel : (focusIndex > -1 ? isIndex : isLabel);

      return [
        'ten-select-option',
        {
          'ten-select-option--selected': this.isChecked,
          'ten-select-option--disabled': this.disabled,
          'ten-select-option--focused': isFocus,
          'ten-select-option--visible': this.visible,
        },
      ];
    },
  },
  methods: {
    onOptionClick() {
      if (this.disabled || this.isSelectAll) return;
      this.select.$emit('option:click', this);
    },
    onOptionMouseEnter() {
      this.select.$emit('option:focus', this);
    },
  },
};
</script>
